import React from 'react'

const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <linearGradient x={15} name='copy' />
    <path
      d='M10 0.625H2.5C1.8125 0.625 1.25 1.1875 1.25 1.875V10.625H2.5V1.875H10V0.625ZM9.375 3.125L13.125 6.875V13.125C13.125 13.8125 12.5625 14.375 11.875 14.375H4.99375C4.30625 14.375 3.75 13.8125 3.75 13.125L3.75625 4.375C3.75625 3.6875 4.3125 3.125 5 3.125H9.375ZM8.75 7.5H12.1875L8.75 4.0625V7.5Z'
      fill='currentColor'
    />
  </svg>
)

export default CopyIcon
